// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App";
import router from "./router";
import $ from "jquery";
import util from "./common/js/util.js";

Vue.use(ElementUI);
Vue.config.productionTip = false;

import footer from "./components/footer/footer.vue";
import header from "./components/header/header.vue";
import navbar from "./components/navbar/navbar.vue";

Vue.prototype.$nav = util.nav;
Vue.prototype.$util = util;

let config = {
  phone: "service@abopin.com",
  email: "bp@abopin.com",
  adEmail: "ad@abopin.com",
  address: "深圳市罗湖区南湖街道嘉南社区春风路3007号桂都大厦十八层1810",
  telephone: "4008067670",
  areaCode: "0086"
};

Vue.prototype.$config = config;

Vue.component("foot", footer);
Vue.component("heads", header);
Vue.component("navbar", navbar);
// Vue.component(Button.name, Button)
// Vue.component(Select.name, Select)

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  $,
  components: { App },
  template: "<App/>"
});
// Vue.use(ElementUI)

// new Vue({
//     el: '#app',
//     render: h => h(App)
// })



// WEBPACK FOOTER //
// ./src/main.js